import { buildApiUrl } from "./client";

// Lille API-hjælper til views, der blot skal hente markedskort.
// Hvis backend-base-url senere ændres, er der nu kun ét sted at rette den.
export async function fetchMarketCards({
  page = 1,
  limit = 4,
  paginated = true,
  sortBy = "price",
  sortDirection = "desc"
} = {}) {
  const searchParams = new URLSearchParams({
    page: String(page),
    limit: String(limit),
    paginated: String(paginated),
    sortBy,
    sortDirection
  });
  const response = await fetch(buildApiUrl(`/api/traders/market/all?${searchParams.toString()}`), {
    credentials: "include"
  });

  if (!response.ok) {
    throw new Error("Could not fetch market cards");
  }

  return response.json();
}